export const locale = {
    lang: 'en',
    data: {
        PHONES_EDIT_FORM: {
            TITLES: {
                PHONE: 'Phone',
                DELETE: 'Delete',
                TYPE: 'Type',
                ADD_NEW: 'Add New',
                OFFICE: 'Office',
                MOBILE: 'Mobile',
                HOME: 'Home',
                OTHER: 'Other',
                USE_FOR_ALERTS: 'Use for Alerts',
                USE_FOR_ALERTS_INFO: 'Use this phone number to receive text message alerts and notifications.'
            },
            ERRORS: {
                CLIENT: {
                    PHONE_TYPE_REQUIRED: 'Phone type is required'
                }
            }
        }
    }
};